export default __webpack_public_path__ + "static/media/clear_sky.a2fab9b9.svg";